module.exports = __webpack_public_path__ + "img/aud1.00c9ddea.png";